module.exports = __webpack_public_path__ + "static/media/paypal_text.407cd002.png";